import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-mov-file-icon',
  templateUrl: './doc-format-mov-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatMovFileIconComponent {}
